import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.ExpanderRoot),
  () => import('./Expander'),
  (Expander) => {
    ComponentUtil.binder(Hooks.ExpanderRoot, Expander);
  },
);
